import { OTPInput, REGEXP_ONLY_DIGITS } from 'input-otp';
import { cn } from '@heroui/react';

interface OtpInputProps {
  value: string;
  onChange: (value: string) => void;
  onComplete?: (value: string) => void;
  disabled?: boolean;
  maxLength?: number;
}

export function OtpInput({
  value,
  onChange,
  onComplete,
  disabled = false,
  maxLength = 6,
}: OtpInputProps) {
  return (
    <OTPInput
      maxLength={maxLength}
      value={value}
      onChange={onChange}
      onComplete={onComplete}
      disabled={disabled}
      pattern={REGEXP_ONLY_DIGITS}
      inputMode="numeric"
      containerClassName="flex items-center justify-center gap-2"
      render={({ slots }) => (
        <>
          <div className="flex items-center gap-2">
            {slots.slice(0, 3).map((slot, index) => (
              <OtpSlot key={index} slot={slot} />
            ))}
          </div>
          <div aria-hidden className="h-1 w-3 rounded-full bg-separator" />
          <div className="flex items-center gap-2">
            {slots.slice(3).map((slot, index) => (
              <OtpSlot key={index + 3} slot={slot} />
            ))}
          </div>
        </>
      )}
    />
  );
}

function OtpSlot({
  slot,
}: {
  slot: {
    char: string | null;
    isActive: boolean;
    placeholderChar: string | null;
  };
}) {
  return (
    <div
      className={cn(
        'flex size-11 items-center justify-center rounded-lg border border-separator bg-surface-secondary text-lg font-semibold text-foreground shadow-none transition',
        slot.isActive && 'border-accent ring-2 ring-accent/30',
      )}
    >
      {slot.char ?? slot.placeholderChar}
    </div>
  );
}
